import { SkuConstraintFormat } from "../constants/SkuConstraintFormat";
import { SkuModalSection } from "../constants/SkuModalSection";
import { SkuWebComponent } from "../constants/SkuWebComponent";

export class SkuDetail {
    elements: SkuDetailSection[];

    constructor({
        response = []
    }) {
        this.elements = response;
    }
}

export class SkuDetailSection {
    ordinal: number;
    stage?: number; 
    webComponent: string;
    modalSection: string;
    sendToServer: boolean;
    webValue?: string | number | undefined | number[] | object[];
    webLabel?: string;
    param?: string;
    constraints?: SkuConstraints;

    constructor({
        ordinal = 0,
        stage = undefined,
        web_component = SkuWebComponent.None,
        modal_section = SkuModalSection.None,
        send_to_server = false,
        web_value = undefined,
        web_label = undefined,
        param = undefined,
        constraints = undefined
    }: any) {
        this.ordinal = ordinal;
        this.stage = stage;
        this.webComponent = web_component;
        this.modalSection = modal_section;
        this.sendToServer = send_to_server;
        this.webValue = web_value;
        this.webLabel = web_label;
        this.param = param;
        this.constraints = constraints;
    }
}

export class SkuConstraints {
    format?: SkuConstraintFormat;
    minLength?: number;
    maxLength?: number;
    minAmount?: number;
    maxAmount?: number;

    constructor({
        format = undefined,
        minlength = undefined,
        maxlength = undefined,
        min_amount = undefined,
        max_amount = undefined
    }: any) {
        this.format = format;
        this.minLength = minlength;
        this.maxLength = maxlength;
        this.minAmount = min_amount;
        this.maxAmount = max_amount;
    }
}

export class SkuParamListener {

    constructor(
        public addParam: (nameParam: string, value: any) => void
    ) { }
}

